import { Visibility, VisibilityOff } from '@material-ui/icons';
import {
  Badge,
  Button,
  Checkbox,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Tooltip
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Icon } from '@progress/kendo-react-common';
import moment from 'moment';
import { useAuth } from 'oidc-react';
import React, { useState } from 'react';
import { Card, Col, Row } from 'reactstrap';
import { getUserId, isOlderThen } from '../../../_helper/helper';
import { Btn } from '../../../AbstractElements';
// import '../HealthOpenEnrollment/Components/benefit.css';
import FileUploadModel from './FileUploadModel';
import { useParams } from 'react-router-dom';

const DependentSelection = (props) => {
  const { dependentInformation, setDependentInformation, initialDependent, handleDependentUpdate, handleDependentDelete, values, handleOpen, dentalPlan } = props
  const [openModel, setOpenModel] = useState(false)
  const [hrControl, setHrControl] = useState("")

  const { employeeId } = useParams()


  const GenderArray = [
    {
      name: "Male",
      value: "male"
    },
    {
      name: "Female",
      value: "female"
    },
  ]


  const RelationArray = [

    {
      name: "Spouse",
      value: "Spouse"
    },
    {
      name: "Domestic Partner",
      value: "Domesticpartner"
    },
    {
      name: "Child",
      value: "Child"
    },

  ]


  const handleAdd = (index) => {
    let addData = [...dependentInformation]
    addData.splice(index + 1, 0, initialDependent);
    // setClassValues(addData)
    setDependentInformation(addData)
  }

  const handleRemove = (index, uid) => {
    let removeData = [...dependentInformation]
    removeData.splice(index, 1);
    handleDependentDelete(uid)
    // setClassValues(removeData)
    setDependentInformation(removeData)
  }

  const renderCheckbox = (index, size = "large", stateName, value, disabled = false) => {
    return (
      <Checkbox
        size={size}
        value={value}
        disabled={disabled}
        stateName={stateName}
        checked={dependentInformation?.[index]?.[stateName] == value}
        onChange={(e) => {
          let data = [...dependentInformation]
          data[index][stateName] = e.target.value
          setDependentInformation(data)
        }}
      />
    );
  };


  function renderTextInput(
    index,
    stateName,
    label,
    others = {}
  ) {
    let other = {
      disabled: false,
      maxLength: '',
      multiline: false,
      required: false,
      shrink: true,
      width: null,
      ...others
    }
    let { disabled, maxLength, multiline, required, shrink, width } = other;

    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: width || "100%",
          },
          maxLength: maxLength,
          readOnly: disabled,
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={dependentInformation?.[index]?.[stateName]}
        InputLabelProps={{ shrink: shrink ? shrink : false }}
        shrink={shrink ? shrink : false}
        onChange={(e) => {
          let data = [...dependentInformation]
          data[index][stateName] = e.target.value
          setDependentInformation(data)
        }}
        // onBlur={handleBlur}
        error={!disabled && required && !dependentInformation?.[index]?.[stateName]}
        helperText={!disabled && required && !dependentInformation?.[index]?.[stateName] && `${label} is required`}
        // disabled={disabled}
        required={required}
      />
    );
  }

  function renderDateInput(
    index,
    stateName,
    label,
    disabled = false,
    minDate = null,
    required = false
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={dependentInformation?.[index]?.[stateName]}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            let data = [...dependentInformation]
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD")
              : null;
            data[index][stateName] = date
            setDependentInformation(data);
          }}
          // onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              style={{ width: "150px" }}
              error={!disabled && required && !dependentInformation?.[index]?.[stateName] ? true : (dependentInformation?.[index]?.relation == 'Child' && isOlderThen(dependentInformation?.[index]?.[stateName])) ? true : false}
              helperText={!disabled && required && !dependentInformation?.[index]?.[stateName] ? `${label} is required` : (dependentInformation?.[index]?.relation == 'Child' && isOlderThen(dependentInformation?.[index]?.[stateName])) ? 'Child Should be not more than 26 years' : ''}
            />
          )}
        />
      </LocalizationProvider>
    );
  }


  function renderDropDown1(index, stateName, label, value, disabled, required = false) {
    return (
      <div>

        <TextField
          margin="dense"
          className="flex w-full  mt-2"
          variant="outlined"
          select
          SelectProps={{ native: true }}
          style={{ width: "160px" }}
          size="small"
          disabled={disabled}
          inputProps={{
            style: {
              fontSize: "14px",
              color: "black",
              paddingTop: "12px",

            },
          }}

          label={label}
          name={stateName}
          value={dependentInformation?.[index]?.[stateName]}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            let data = [...dependentInformation]
            data[index][stateName] = e.target.value
            // setClassValues(dependentInformation)
            setDependentInformation(data)
          }}
          error={!disabled && required && values != "I" && !dependentInformation?.[index]?.[stateName] && !dependentInformation?.[index]?.[stateName]}
          helperText={!disabled && required && values != "I" && !dependentInformation?.[index]?.[stateName] && `${label} is required`}
        // value={values[stateName]}
        >
          {/* <option value={""} disabled> */}
          {/* value={values[stateName]}> */}
          <option value={""}>
            Select {label}
          </option>

          {value.length &&
            value.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
        </TextField>
      </div >
    );
  }



  function renderPasswordInput(
    index,
    stateName,
    label,
    others = {
      disabled: false,
      multiline: false,
      required: false,
      maxLength: "",
      shrink: true,
    }
  ) {
    let other = {
      disabled: false,
      multiline: false,
      required: false,
      shrink: true,
      ...others,
    };

    let { disabled, multiline, required, shrink, width, maxLength } = other;
    return (

      <FormControl sx={{ mt: 1, width: "155px" }} variant="outlined">
        <InputLabel error={!disabled && required && !dependentInformation?.[index]?.[stateName] ? true : dependentInformation?.[index]?.[stateName].length != 9 ? true : false
        } required shrink={true} htmlFor="outlined-adornment-password">{label}</InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          type={dependentInformation?.[index]?.["isSSN"] ? "text" : "password"}
          size="small"
          inputProps={{
            maxLength: maxLength,
            readOnly: disabled,
          }}
          notched={true}

          name={stateName}
          value={dependentInformation[index][stateName]}
          // InputLabelProps={{ shrink: other.shrink ? other.shrink : false }}
          onChange={(e) => {
            let data = [...dependentInformation];
            data[index][stateName] = e.target.value;
            setDependentInformation(data);
          }}
          disabled={other.disabled}
          required={other.required}
          error={
            !disabled && required && !dependentInformation?.[index]?.[stateName] ? true : dependentInformation?.[index]?.[stateName].length != 9 ? true : false
          }

          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => {
                  let data = [...dependentInformation];
                  data[index]["isSSN"] = !data?.[index]?.["isSSN"]
                  setDependentInformation(data);
                }}
                edge="end"
              >
                {dependentInformation?.[index]?.["isSSN"] ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          label={label}
        />
        {
          (!disabled &&
            required &&
            !dependentInformation?.[index]?.[stateName]) ? <FormHelperText error={true}>{`${label} is required`}</FormHelperText> :
            dependentInformation?.[index]?.[stateName].length != 9 &&
            <FormHelperText error={true}>{`${label} must be exactly 9 characters`}</FormHelperText>
        }


      </FormControl>
    );
  }
  const { userData } = useAuth();
  const userID = getUserId(userData)

  return (
    <Card style={{ padding: "20px", overflow: "auto" }}>
      <FileUploadModel
        isOpen={openModel}
        handleClose={() => {
          setOpenModel(false);
        }}
        hrControl={hrControl}
        approvalBtn={true}
        docSelectionON={true}
        employeeId={employeeId}
      />
      {dependentInformation.length ?
        <table className='benefitTable '>
          <thead>
            <tr>
              <th>#</th>
              <th>First Name</th>
              <th>Middle Name</th>
              <th>Last Name</th>
              <th>Relation</th>
              {/* <th>SSN</th> */}
              <th>Gender</th>
              <th>DOB</th>
              <th>Mailing Address</th>
              <th>Email</th>

            </tr>
          </thead>
          {dependentInformation?.map((item, index) => {
            let readonly = false //dependentInformation[index]["relation"].includes('Coverage') ? true : false;
            return (
              <tr className={dependentInformation[index]["role"].includes('Coverage') ? 'boxdisabled' : index % 2 ? "mtbox2" : "mtbox"}  >
                <td
                  style={{
                    minWidth: "100px",
                    padding: "15px 5px 0px 5px",
                    display: "flex",
                  }}
                >
                  <Checkbox
                    // size={}
                    checked={((!dependentInformation[index]["role"].includes('Coverage')) && dependentInformation[index]["DentalSubscriberID"]) ? true : false}                  // disabled={(dependentInformation[index]["relation"].includes('Coverage')) ? true : false}
                    onChange={(e) => {
                      let data = [...dependentInformation];
                      data[index]['DentalSubscriberID'] = e.target.checked ? employeeId : "";
                      if (e.target.checked == false) {
                        // data[index]['relation'] = "";
                      }
                      setDependentInformation(data);
                    }}
                  />
                  <Tooltip
                    title={`Upload Document (Total Doc - ${item.Total_document || 0} ,Verified - ${item.TotalVerifiedDoc || 0},Rejected - ${item.TotalRejectedDoc || 0})`}
                    placement="bottom"
                  >
                    <Badge
                      color="secondary"
                      badgeContent={
                        item.Total_document ? parseInt(item.Total_document) : 0
                      }
                      style={{ marginRight: "10px" }}
                    >

                      <IconButton
                        onClick={() => {
                          setHrControl(`BE-${item?.rowId}`)
                          setOpenModel(true)
                        }}
                        style={{
                          // marginRight: "10px",
                          // marginTop: "10px",
                          margin: "5px",
                          color: "primary",
                          height: "20px",
                          width: "20px",
                          justifyContent: "center",
                          // border: `1px solid`,
                          borderRadius: "50%",
                          // padding: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <i className="fa-duotone fa-file-arrow-up font-primary"></i>
                      </IconButton>

                    </Badge>
                  </Tooltip>
                </td>


                <td md={3} style={{ width: "165px" }} >
                  {renderTextInput(index, "firstName", "First Name", {
                    required: true,
                    width: "165px",
                    disabled: readonly
                  })}
                </td>
                <td md={2} style={{ width: "155px" }} >
                  {renderTextInput(index, "middleName", "Middle Name", {
                    width: "155px",
                    required: true,
                    maxLength: 1,
                    disabled: readonly
                  })}
                </td>
                <td md={3} style={{ width: "165px" }} >
                  {renderTextInput(index, "lastName", "Last Name", {
                    width: "165px",
                    required: true,
                    disabled: readonly
                  })}
                </td>

                <td md={2} style={{ width: "155px" }} >
                  {renderDropDown1(
                    index,
                    "relation",
                    "Relation",
                    RelationArray,
                    readonly ? true : item.DentalSubscriberID ? false : true,
                    true
                  )}
                </td>

                {/* <td md={2} style={{ width: "155px" }} >
                {item?.uid ? <div className='midAlign' style={{ textAlign: "center", width: '155px' }}> ----</div> :
                  renderPasswordInput(index, "ssn", "SSN", {
                    maxLength: 9,
                    width: "150px",
                    required: true,
                  })
                }
              </td> */}
                <td md={5} style={{ width: "200px" }} >

                  <div style={{ display: "flex", marginRight: "5px" }}>
                    <span style={{ display: "flex" }}>
                      <span>{renderCheckbox(index, "medium", "gender", "Male", readonly)}{" "}</span>
                      <span style={{ alignSelf: "center" }}>Male</span>
                    </span>
                    <span style={{ display: "flex" }}>
                      <span>{renderCheckbox(index, "medium", "gender", "Female", readonly)}{" "}</span>
                      <span style={{ alignSelf: "center" }}> Female</span>
                    </span>
                    <span style={{ display: "flex" }}>
                      <span>{renderCheckbox(index, "medium", "gender", "Other", readonly)}{" "} </span>
                      <span style={{ alignSelf: "center" }}> Other </span>
                    </span>
                  </div>
                  <div>
                    {
                      !item.gender && <FormHelperText className='text-center' error >Please Select Gender</FormHelperText>
                    }
                  </div>
                </td>

                <td md={2} style={{ width: "200px" }} >
                  {renderDateInput(index, "dob", "Date of Birth", readonly, readonly, false)}
                </td>
                <td md={2} style={{ width: "200px" }} >
                  {renderTextInput(
                    index,
                    "mailingAddress",
                    "Mailing Address",
                    {
                      width: "200px",
                      disabled: readonly
                    }
                  )}
                </td>
                <td md={3} style={{ width: "200px" }} >
                  {renderTextInput(index, "email", "Email Address", {
                    width: "200px",
                    disabled: readonly
                  })}
                </td>

              </tr>


            )
          })}
        </table>
        : <div>No dependent found</div>}


      {/* {dependentInformation?.map((item, index) => {
        return (
          <Row className={index % 2 ? "mtbox2" : "mtbox"}>
            <div className='depcounter'>{index + 1}</div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "98%" }}>
                <Row>
                  <Col md={3}>
                    {renderTextInput(index, "firstName", "First Name", { required: true })}
                  </Col>
                  <Col md={2}>
                    {renderTextInput(index, "middleName", "Middle Name", { required: true })}
                  </Col>
                  <Col md={3}>
                    {renderTextInput(index, "lastName", "Last Name", { maxLength: 4, required: true })}
                  </Col>
                  <Col md={2}>
                    {renderDropDown1(index, "relation", "Relation to Subscriber", RelationArray, false)}
                  </Col>
                  <Col md={2}>
                    {renderTextInput(index, "ssn", "Social Security Number", { maxLength: 9, required: true })}
                  </Col>
                </Row>
                <Row>

                  <Col md={3}>
                     <div style={{ display: 'flex' }}>
                       <span>{renderCheckbox(index, "medium", "gender", "Male")} Male</span>
                      <span>
                        {renderCheckbox(index, "medium", "gender", "Female")} Female
                      </span>
                      <span>
                        {renderCheckbox(index, "medium", "gender", "Other")} Other
                      </span>
                    </div>
                  </Col>
                  <Col md={3}>
                    {renderDateInput(index, "dob", "Date of Birth", false, null, true)}
                  </Col>
                  <Col md={3}>
                    {renderTextInput(index, "mailingAddress", "Mailing Address")}
                  </Col>
                  <Col md={3}>
                    {renderTextInput(index, "email", "Email Address")}
                  </Col>
                </Row>

                <Row className='mt-2 mb-2 justify-content-end'>
                  <Col md={"auto"}>
                    <Btn
                      attrBtn={{
                        color: "primary",
                        style: { width: "100%" },
                        disabled: item.ssn && item.subscriberId ? false : true,
                        onClick: () => {
                          setHrControl(`${item.ssn}${item.subscriberId}`)
                          setOpenModel(true)
                        },
                      }}
                    >
                      <Icon style={{ fontSize: '18px' }} name="plus" /> Upload Document
                    </Btn>
                  </Col>
                </Row>
              </div>
              <div style={{ display: "flex", justifyContent: "center", alignSelf: "center", marginLeft: "15px" }}>
                {
                  dependentInformation.length != 1 ? <Icon onClick={() => handleRemove(index, item.uid)}
                    style={{
                      marginRight: "10px",
                      marginTop: "10px",
                      color: "red",
                      height: "20px",
                      width: "20px",
                      justifyContent: "center",
                      border: `1px solid ${"red"
                        }`,
                      borderRadius: "20px",
                    }} className="m-r-10" name="minus-circle" /> : null
                }

                {
                  (dependentInformation.length == 1 || (dependentInformation.length - 1 == index)) ?
                    <Icon onClick={() => handleAdd(index)}
                      style={{
                        marginRight: "10px",
                        marginTop: "10px",
                        color: "green",
                        height: "20px",
                        width: "20px",
                        justifyContent: "center",
                        border: `1px solid ${"green"
                          }`,
                        borderRadius: "20px",
                      }} className="m-r-10" name="plus-circle" /> : null}


              </div>
            </div>
          </Row>
        )
      })} */}
      <Row className='mt-3'>
        {/* {dependentInformation.length ? */}

        <Col md={"auto"}>
          <Btn
            attrBtn={{
              color: "primary",
              style: { width: "100%" },
              onClick: () => { handleDependentUpdate() },
            }}
          >
            <Icon style={{ fontSize: '18px' }} name="save" /> &nbsp; Update Dependent
          </Btn>
        </Col>


        {/* : null} */}
        <Col md={"auto"}>
          <Button
            type={"button"}
            // style={{ color: "white",backgroundColor:"white",marginLeft:"22px"}}
            variant="contained"
            className="btn btn-primary ml-2"
            onClick={handleOpen}
            disabled={!dentalPlan}
          >
            + Add Dependent
          </Button>
        </Col>

      </Row>

    </Card >
  )
}

export default DependentSelection